import PorPrincipioActivo from "layouts/dashboards/por_principio_activo";

// Material Dashboard 2 PRO React components

// @mui icons
import Icon from "@mui/material/Icon";
import swal from "sweetalert";
// Images
import MarketAnalysis from "layouts/dashboards/analisis_del_mercado";
import ComapaniesContrast from "layouts/dashboards/comparar_empresas";
import ProductsByCompany from "layouts/dashboards/productos_por_empresa";
import SalesSummary from "layouts/dashboards/resumen_ventas";
import SalesBySector from "layouts/dashboards/ventas_por_sector";
import SalesPerQuarter from "layouts/dashboards/ventas_por_trimestre";

import AensaCatalogs from "layouts/catalogs";
import CatastroAlmacenes from "layouts/catastros/catastro_almacenes";
import CatastroMapaAlmacenes from "layouts/catastros/mapa_almacenes";
import CatastroNacionalPorEspecie from "layouts/catastros/nacional_por_especie";
import Companies from "layouts/companies";
import MarketStudy from "layouts/dashboards/market_study";
import SuperIntendenciaCompanies from "layouts/info_emevet/super_intendencia_companias";
import TopIntendenciaCompanies from "layouts/info_emevet/top_empresas_superintendencia";
import Products from "layouts/products";
import RegisterSales from "layouts/sales_records/sales";
import SecurityReportQueries from "layouts/security/reports_queries";
import AensaUsers from "layouts/users";

const routes = [
  { type: "title", title: "Menu Principal", key: "menu-principal" },
  {
    type: "collapse",
    name: "Reportes",
    key: "Reportes",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    collapse: [
      {
        name: "Resumen de Ventas",
        key: "sales_summary",
        route: "/reportes/resumen_ventas",
        component: <SalesSummary />
      },
      {
        name: "Por Principio Activo",
        key: "por_principio_activo",
        route: "/reportes/por_principio_activo",
        component: <PorPrincipioActivo />
      },
      {
        name: "Ventas por Trimestre",
        key: "VentasPorTrimestre",
        route: "/reportes/Ventas_Por_Trimestre",
        component: <SalesPerQuarter />
      },
      {
        name: "Ventas por Sector",
        key: "VentasPorSector",
        route: "/reportes/Ventas_Por_Sector",
        component: <SalesBySector />
      },
      {
        name: "Productos por Empresa",
        key: "ProductosPorEmpresa",
        route: "/reportes/Productos_Por_Empresa",
        component: <ProductsByCompany />
      },
      {
        name: "Analisis del Mercado",
        key: "AnalisisDelMercado",
        route: "/reportes/Analisis_Del_Mercado",
        component: <MarketAnalysis />
      },
      {
        name: "Comparar Empresas",
        key: "CompararEmpresas",
        route: "/reportes/Comparar_Empresas",
        component: <ComapaniesContrast />
      },
      {
        name: "Inteligencia de Negocio",
        key: "Inteligencia de Negocio",
        route: "/reportes/Estudio_de_Mercado",
        component: <MarketStudy />
      }
    ]
  },
  {
    type: "collapse",
    name: "Registros",
    key: "registros",
    icon: <Icon fontSize="medium">folder</Icon>,
    collapse: [
      {
        name: "Ventas",
        key: "ventas",
        route: "/registros/ventas",
        component: <RegisterSales />
      }
    ]
  },
  {
    type: "collapse",
    name: "Info Emevet",
    key: "info-emevet",
    icon: <Icon fontSize="medium">folder</Icon>,
    collapse: [
      {
        name: "S.I. Top Empresas",
        key: "stop_companies_superintendencia",
        route: "/Info_Emevet/Top_Empresas_Superintendencia",
        component: <TopIntendenciaCompanies />
      }
    ]
  },
  {
    type: "collapse",
    name: "Catastros",
    key: "Catastros",
    icon: <Icon fontSize="medium">folder</Icon>,
    collapse: [
      {
        name: "Nacional Por Especies",
        key: "Catastro_Nacional_Por_Especies",
        route: "/Catastros/Nacional_Por_Especies",
        component: <CatastroNacionalPorEspecie />
      },
      {
        name: "Mapa Almacenes",
        key: "Mapa_Almacenes",
        route: "/Catastros/Mapa_Almacenes",
        component: <CatastroMapaAlmacenes />
      }
    ]
  },
  { type: "divider", key: "divider-1" },
  { type: "title", title: "Administración", key: "admin", allowedRoles: ["ADMIN"] },
  {
    type: "collapse",
    name: "Usuarios",
    key: "Usuarios",
    icon: <Icon fontSize="medium">people</Icon>,
    route: "/Administracion/Usuarios",
    noCollapse: true,
    allowedRoles: ["ADMIN"],
    collapse: [
      {
        name: "Usuarios",
        key: "Usuarios",
        route: "/Administracion/Usuarios",
        component: <AensaUsers />
      }
    ]
  },
  {
    type: "collapse",
    name: "Catalogos",
    key: "Catalogos",
    icon: <Icon fontSize="medium">storage</Icon>,
    route: "/Administracion/Catalogos",
    noCollapse: true,
    allowedRoles: ["ADMIN"],
    collapse: [
      {
        name: "Catalogos",
        key: "Catalogos",
        route: "/Administracion/Catalogos",
        component: <AensaCatalogs />
      }
    ]
  },
  {
    type: "collapse",
    name: "Empresas",
    key: "Empresas",
    icon: <Icon fontSize="medium">business</Icon>,
    route: "/Administracion/Empresas",
    noCollapse: true,
    allowedRoles: ["ADMIN"],
    collapse: [
      {
        name: "Empresas",
        key: "Empresas",
        route: "/Administracion/Empresas",
        component: <Companies />
      }
    ]
  },
  {
    type: "collapse",
    name: "Productos",
    key: "Productos",
    icon: <Icon fontSize="medium">category</Icon>,
    route: "/Administracion/Productos",
    noCollapse: true,
    allowedRoles: ["ADMIN"],
    collapse: [
      {
        name: "Productos",
        key: "Productos",
        route: "/Administracion/Productos",
        component: <Products />
      }
    ]
  },
  {
    type: "collapse",
    name: "Catastros Almacenes",
    key: "Catastros-Almacenes",
    icon: <Icon fontSize="medium">warehouse</Icon>,
    route: "/Administracion/Catastros_Almacenes",
    noCollapse: true,
    allowedRoles: ["ADMIN"],
    collapse: [
      {
        name: "Catastros Almacenes",
        key: "Catastros-Almacenes",
        route: "/Administracion/Catastros_Almacenes",
        component: <CatastroAlmacenes />
      }
    ]
  },
  {
    type: "collapse",
    name: "S.I. Companias",
    key: "super_intendencia_companias",
    icon: <Icon fontSize="medium">leaderboard</Icon>,
    route: "/Info_Emevet/Datos_Superintendencia_de_Companias",
    noCollapse: true,
    allowedRoles: ["ADMIN"],
    collapse: [
      {
        name: "S.I. Companias",
        key: "super_intendencia_companias",
        route: "/Info_Emevet/Datos_Superintendencia_de_Companias",
        component: <SuperIntendenciaCompanies />
      }
    ]
  },
  {
    type: "collapse",
    name: "Seguridad",
    key: "Seguridad",
    allowedRoles: ["ADMIN"],
    icon: <Icon fontSize="medium">security</Icon>,
    collapse: [
      {
        name: "Consulta de Reportes",
        key: "Consulta_Reportes",
        route: "/administracion/seguridad/consulta_de_reportes",
        component: <SecurityReportQueries />
      }
    ]
  }
];

let alertaMostrada = false;

export function getRoutesByUser(user) {
  // 1️⃣ Sin usuario → sin rutas
  if (!user) {
    return [];
  }

  // 2️⃣ Usuario sin roles → alerta + BLOQUEAR acceso total
  if (!Array.isArray(user.roles) || user.roles.length === 0) {
    if (!alertaMostrada) {
      alertaMostrada = true;
      swal(
        "Usuario sin roles",
        "Tu cuenta no tiene roles asignados. Contacta al administrador.",
        "warning"
      ).then(() => {
        // 🚪 Cerrar sesión y redirigir al login
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/authentication/sign-in";
      });
    }
    // ⛔ NO devolver rutas → usuario no puede navegar a ningún lado
    return [];
  }

  // 3️⃣ Reset del flag si el usuario ya tiene roles (por si cambia de cuenta)
  if (alertaMostrada) {
    alertaMostrada = false;
  }

  // 4️⃣ Extraer roles seguros
  const userRoles = user.roles.map((r) => r?.role).filter(Boolean);

  // 5️⃣ Filtrar rutas según roles
  return routes.filter((route) => {
    if (!route.allowedRoles || route.allowedRoles.length === 0) return true;
    return route.allowedRoles.some((allowedRole) =>
      userRoles.includes(allowedRole)
    );
  });
}

export default routes;